import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Style = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
    padding: 2rem 70px 1rem;
    margin: 0 auto;
    width: calc(100% - 140px);
    isolation: isolate;
    background-color: var(--n-bg-1);
    .title {
        z-index: 5;
        font-size: 1.6rem;
        font-weight: 800;
        margin-bottom: 1.3rem;
        letter-spacing: 1px;
    }
    .items {
        display: grid;
        --grid-col: 3;
        --grid-gap: 1rem;
        --grid-row-gap: 1rem;
        grid-template-columns: repeat(var(--grid-col), calc(calc(100% / var(--grid-col)) - calc(calc(var(--grid-gap) * calc(var(--grid-col) - 1)) / var(--grid-col))));
        grid-gap: var(--grid-gap);
        grid-row-gap: var(--grid-row-gap);
        justify-content: center;
        .card {
            border-radius: 0.5rem;
            /* background-color: aliceblue; */
            overflow: hidden;
            /* padding: 1rem 0.5rem; */
            .card-image {
                width: 100%;
                height: 100%;
                position: relative;
                img {
                    width: 100%;
                    display: block;
                    object-fit: fill;
                    mix-blend-mode: multiply;
                }
            }
        }
    }
    @media (max-width: 850px){
        width: calc(100% - 32px);
        padding: 1rem 16px 1rem;
        .items {
            --grid-col: 1;
            --grid-gap: 1rem;
            --grid-row-gap: 1rem;
        }
    }
`;

export default function CenterItemsImage({data}) {
    const makeCards = () => {
        return data.data.map((value, index) => {
            return (
                <Link to={value.link} key={index} className="card">
                    <div className="card-image"  alt={value.title}>
                        <img src={value.image} alt={value.title}/>
                    </div>
                </Link>
            )
        })
    }
    return (
      <Style>
        <div className="title">
            {data.title}
        </div>
        <div className="items">
            {makeCards()}
        </div>
      </Style>
  );
}
